import React from 'react';
import { LoadingIcon, colors } from '@chegg-ui/theme';
import { LoadingInlineWrapper, LoadingOverlayWrapper } from './styled';
import { LoadingIndicatorStyle } from './types';
var getWrapper = function getWrapper() {
  var LoadingType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LoadingIndicatorStyle.INLINE;
  switch (LoadingType) {
    case LoadingIndicatorStyle.OVERLAY:
      return LoadingOverlayWrapper;
    case LoadingIndicatorStyle.INLINE:
    default:
      return LoadingInlineWrapper;
  }
};
var LoadingIndicator = function LoadingIndicator(props) {
  var Wrapper = getWrapper(props.LoadingType);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    "aria-live": 'assertive',
    role: 'alertdialog',
    "aria-label": 'Payment form is loading...'
  }, /*#__PURE__*/React.createElement(LoadingIcon, {
    id: 'loading-animation-story',
    color: colors.cheggOrange,
    size: 'large'
  })));
};
export default LoadingIndicator;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/LoadingIndicator/index.js
// module id = 336
// module chunks = 11